import {
  ArrowLeftRight,
  BarChart3,
  Bell,
  Cloud,
  FolderOpen,
  LayoutDashboard,
  ListVideo,
  PlusCircle,
  ShieldCheck,
  SlidersHorizontal,
  Wrench,
  type LucideIcon,
} from 'lucide-react';

export interface VodNavEntry {
  slug: string;
  label: string;
  icon: LucideIcon;
}

export interface VodNavGroup {
  heading: string;
  entries: VodNavEntry[];
}

/**
 * Cloud Encoding console sidebar — mirrors the legacy grouping
 * (VOD Transcoding workflow vs. delivery/settings) with v2 contextual nav.
 */
export const VOD_NAV: VodNavGroup[] = [
  {
    heading: 'VOD Transcoding',
    entries: [
      { slug: '', label: 'Dashboard', icon: LayoutDashboard },
      { slug: 'jobs', label: 'Jobs', icon: ListVideo },
      { slug: 'jobs/create', label: 'Create Job', icon: PlusCircle },
      { slug: 'watch-folders', label: 'Watch Folders', icon: FolderOpen },
      { slug: 'transcoding-presets', label: 'Transcoding Presets', icon: SlidersHorizontal },
      { slug: 'usage', label: 'Analytics', icon: BarChart3 },
    ],
  },
  {
    heading: 'Settings',
    entries: [
      { slug: 'file-transfer', label: 'File Transfer', icon: ArrowLeftRight },
      { slug: 'notifications', label: 'Notifications', icon: Bell },
      { slug: 'cdn-endpoints', label: 'CDN Endpoints', icon: Cloud },
      { slug: 'verimatrix-drms', label: 'Verimatrix DRMs', icon: ShieldCheck },
      { slug: 'provisioning', label: 'Provisioning', icon: Wrench },
    ],
  },
];

/** Full href for a slug under `base`. */
export function vodHrefFor(base: string, slug: string): string {
  return slug ? `${base}/${slug}` : base;
}

/** Longest nav slug that prefixes `subPath` → active sidebar entry. */
export function vodActiveSlug(subPath: string): string {
  const slugs = VOD_NAV.flatMap((g) => g.entries.map((e) => e.slug)).filter(Boolean);
  let best = '';
  for (const slug of slugs) {
    if ((subPath === slug || subPath.startsWith(`${slug}/`)) && slug.length > best.length) best = slug;
  }
  return best;
}
